<template>
  <div id="newsdetail">
    <div class="page_tit_box">
      <div class="center_content u-flex">
        <div>
          <img
            class="tit_img"
            src="../../assets/images/index_icon1.png"
            alt=""
          />
        </div>
        <div>首页>保函查询>保函详情</div>
      </div>
    </div>
    <!-- 进度轴 -->
    <div class="center_box">
      <div class="detail_tit">申请保函</div>

      <div class="steps_box">
        <el-steps class="mysteps" :active="index" align-center>
          <el-step title="填写资料" description=""></el-step>
          <el-step title="核保" description=""></el-step>
          <el-step title="费用支付" description=""></el-step>
          <el-step title="完成" description=""></el-step>
        </el-steps>
      </div>
      <!-- page1 -->
      <div class="page1" v-show="index == 0">
        <div class="pagetit">
          <img src="../../assets/images/xmxx.png" alt="" />
        </div>
        <div class="form_box">
          <el-form
            class="ser_form"
            ref="detailForm"
            label-position="right"
            label-width="130px"
            :hide-required-asterisk="true"
            :model="detailForm"
            :rules="rules"
          >
            <el-form-item class="s_form_t" label="标段编号" prop="zbWjbh">
              <el-input
                class="inlineInput"
                v-model="detailForm.zbWjbh"
                disabled
                placeholder="请输入标段编号"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="招标单位" prop="zbDwname">
              <el-input
                class="inlineInput"
                v-model="detailForm.zbDwname"
                disabled
                placeholder="请输入招标单位"
              ></el-input>
            </el-form-item>

            <el-form-item class="s_form_t" label="开标时间" prop="kbDate">
              <el-date-picker
                class="inlineInput"
                v-model="detailForm.kbDate"
                disabled
                type="date"
                placeholder="选择开标时间"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="s_form_t" label="保函有效期至" prop="endDate">
              <el-date-picker
                :clearable="false"
                class="inlineInput"
                disabled
                v-model="detailForm.endDate"
                type="date"
                placeholder="选择保函有效期至"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="s_form_t" label="保证金金额(元)" prop="money">
              <el-input
                class="inlineInput"
                disabled
                v-model="detailForm.money"
                placeholder="请输入保证金金额"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- <div class="rzxz_box">
          <div class="rzxz_tit">温馨提示：</div>
          <div class="rzxz_txt">
            保函收费标准：<br />
            保证金2万以下收费300元，2-10万(包含)以内收费500元； <br />
            保证金10万以上按保证金额的千分之五进行收费。 <br /><br />

            如有遇到急需处理的问题，请立即联系客服，客服竭诚为您服务，感谢您的理解与支持！
          </div>
        </div> -->

        <div class="certbtn_box">
          <el-button class="certbtn" type="primary" @click="step()"
            >下一步</el-button
          >
        </div>
      </div>

      <!-- page2 -->
      <el-dialog
        title=""
        class="page4"
        :show-close="false"
        :center="true"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
      >
        <div class="page4_tit">选择担保公司</div>
        <div class="danbaotypebtn">
          <el-radio-group
            v-model="danbaoType"
            size="medium"
            class="mycheck_box"
            @change="changedbType"
          >
            <el-radio-button
              v-for="(item, index) in baohanTypeArr"
              :key="index"
              :label="item"
            >
              {{
                item == "1" ? "担保保函" : item == "2" ? "银行保函" : "保险保函"
              }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="page4_center">
          <el-radio-group class="dialogRadio" v-model="company">
            <el-radio-button
              :label="item.id"
              v-for="(item, index) in guaranteeList"
              :key="index"
            >
              <!-- <img :src="baseUrl+item.url" alt=""> -->
              {{ item.name }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="certbtn_c diolg_btn" @click="close()"
            >取消</el-button
          >
          <el-button
            class="certbtn diolg_btn"
            type="primary"
            @click="nextFun2()"
            >下一步</el-button
          >
        </span>
      </el-dialog>

      <!-- page3 -->
      <div class="page2" v-show="index == 2">
        <div class="pagetit">
          <img src="../../assets/images/xxzf.png" alt="" />
        </div>
        <div class="page_money">
          <div class="tips">备注：请核实招标文件是否基本户对公转款</div>
          <div class="num">{{ danbaoObj.money }}</div>
          <div class="txt">应付金额(元)</div>
        </div>

        <div class="u-flex u-row-between cert_b_box">
          <div class="cert_box">
            <div class="cert_tt">银行打款</div>
            <div class="cert_tt_bg">
              <div class="cert_tt_bg_t">山西华晋担保账户信息</div>
              <div class="cert_tt_bg_b">
                账户名称：山西华晋工程担保有限公司 <br />
                打款账号：692488029<br />
                开户行：中国民生银行股份有限公司太原亲贤北街支行<br />
                开户行行号：305161009063<br />
              </div>
            </div>
          </div>

          <div class="cert_box">
            <div class="cert_tt">支付宝</div>
            <div class="cert_tt_bg blue">
              <div class="zf_t">打开支付宝[扫一扫]</div>
              <div class="zf_c">
                <img src="../../assets/images/zfb.png" alt="" />
              </div>
              <div class="zf_b">武永川(**川)</div>
            </div>
          </div>

          <div class="cert_box">
            <div class="cert_tt">微信支付</div>
            <div class="cert_tt_bg green">
              <div class="zf_t">打开微信[扫一扫]</div>
              <div class="zf_c">
                <img src="../../assets/images/wx.png" alt="" />
              </div>
              <div class="zf_b">山西华晋工程担保有限公司(**霞)</div>
            </div>
          </div>
        </div>

        <div class="file_box">
          <el-upload
            :on-remove="handleRemove"
            action="/tbbh/front/common/upload"
            :limit="1"
            :on-exceed="handleExceed"
            :on-success="zfSuccess"
            :before-upload="beforeAvatarUpload"
            :file-list="fileList"
            :auto-upload="true"
          >
            <div slot="tip" class="el-upload__tip">
              打款成功后请上传转账凭证
            </div>
            <el-button class="file_btn" type="primary">选择文件</el-button>
          </el-upload>
        </div>

        <div class="certbtn_box">
          <el-button class="certbtn" type="primary" @click="zhifuPay()"
            >完成</el-button
          >
        </div>

        <div class="checkspan">
          <el-checkbox v-model="checked"></el-checkbox>
          <span class="checkbox_txt"
            >我已阅读<span class="a_link" @click="openUrl()"
              >《用户须知》</span
            ></span
          >
        </div>
      </div>

      <!-- page4 -->
      <div class="page4" v-show="index == 3">
        <div class="result_img" v-if="detailForm.status == '3'">
          <img src="../../assets/images/sqz.png" alt="" />
          <div class="result_txt">您的申请正在审核</div>
        </div>

        <div class="result_img" v-if="detailForm.status == '5'">
          <img src="../../assets/images/ywc.png" alt="" />
          <div class="result_txt">您的申请已完成</div>
        </div>

        <div class="result_img" v-if="detailForm.status == '-1'">
          <img src="../../assets/images/wtg.png" alt="" />
          <div class="result_txt">您的申请被驳回</div>
        </div>

        <div class="certbtn_box" v-if="detailForm.status == '-1'">
          <el-button class="certbtn" type="primary" @click="init()"
            >重新申请</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from "qs";
import { sesStorage } from "@/model/storage.js";
import config from "@/model/config.js";

export default {
  data() {
    return {
      index: 0,
      checked: true,
      detailForm: {},
      guaranteeList: [],
      dialogVisible: false,
      company: "",
      danbaoObj: {},
      fileList: [],
      rules: {},
      zfUrl: "",
      hasOrder: false,
      baseUrl: config.URL,
      baohanTypeArr: [],
      project: {},
      danbaoType: "",
    };
  },
  components: {},
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    close() {
      this.dialogVisible = false;
    },
    nextFun2() {
      if (this.company) {
        let data = {
          id: this.$route.query.id,
          token: sesStorage.get("userObj").token,
          danbaoId: this.company,
        };
        this.$http
          .post("/front/project/danbaoSave", Qs.stringify(data))
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: res.data.msg,
                type: "success",
                center: true,
              });
              this.dialogVisible = false;
              this.index = 2;
              this.danbaoObj = res.data.data;
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
              if (res.data.code == 201) {
                setTimeout(() => {
                  this.$router.push({ path: "/home/login" });
                }, 1000);
              }
            }
          });
      } else {
        this.$message({
          message: "请选择担保公司",
          type: "error",
          center: true,
        });
      }
    },
    step() {
      this.dialogVisible = true;
    },
    getguarantee() {
      let data = {
        token: sesStorage.get("userObj").token,
        id: this.detailForm.id,
        danbaoType: this.danbaoType,
      };
      this.$http
        .post("/front/project/selectDanbaoById", Qs.stringify(data))
        .then((res) => {
          if (res.data.code == 0) {
            this.guaranteeList = res.data.data;
            if (this.guaranteeList && this.guaranteeList.length > 0) {
              this.company = this.guaranteeList[0].id;
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
              center: true,
            });
            if (res.data.code == 201) {
              setTimeout(() => {
                this.$router.push({ path: "/home/login" });
              }, 1000);
            }
          }
        });
    },

    zfSuccess(res, file) {
      if (res.code == 0) {
        this.$message({
          message: res.msg,
          type: "success",
          center: true,
        });
        this.zfUrl = res.data.fileName;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
          center: true,
        });
      }
    },
    // 支付
    zhifuPay() {
      if (this.checked) {
        if (this.danbaoType == "2" || this.danbaoType == "3") {
          this.$confirm("1-3个工作日出函", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              let data = {
                token: sesStorage.get("userObj").token,
                zfUrl: this.zfUrl,
                id: this.danbaoObj.id,
              };
              this.$http
                .post("/front/project/zhifu", Qs.stringify(data))
                .then((res) => {
                  if (res.data.code == 0) {
                    this.detailForm.status = "3";
                    this.index = 3;
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                      center: true,
                    });
                    if (res.data.code == 201) {
                      setTimeout(() => {
                        this.$router.push({ path: "/home/login" });
                      }, 1000);
                    }
                  }
                });
            })
            .catch(() => {});
        } else {
          let data = {
                token: sesStorage.get("userObj").token,
                zfUrl: this.zfUrl,
                id: this.danbaoObj.id,
              };
              this.$http
                .post("/front/project/zhifu", Qs.stringify(data))
                .then((res) => {
                  if (res.data.code == 0) {
                    this.detailForm.status = "3";
                    this.index = 3;
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                      center: true,
                    });
                    if (res.data.code == 201) {
                      setTimeout(() => {
                        this.$router.push({ path: "/home/login" });
                      }, 1000);
                    }
                  }
                });
        }
      } else {
        this.$message({
          message: "请阅读《用户须知》",
          type: "error",
          center: true,
        });
      }
    },
    init() {
      this.detailForm = this.$route.query.obj;
      if (this.$route.query.project) {
        this.project = this.$route.query.project;
        // 储存担保类型
        if (this.project.danbaoType) {
          let danbaoTypeStr = this.project.danbaoType;
          this.baohanTypeArr = danbaoTypeStr.split(",");
          this.danbaoType = this.baohanTypeArr[0];
        }
      }
      this.detailForm.status = this.$route.query.status;
      this.hasOrder = this.$route.query.hasOrder;
      if (this.hasOrder) {
        if (this.detailForm.status == 1) {
          this.index = 2;
        } else {
          this.index = 3;
        }
        //已经有的单子获取单子详情
        this.danbaoObj = this.$route.query.obj;
        this.danbaoObj.id = this.$route.query.id;
        this.danbaoType = this.$route.query.dbType;
      } else {
        this.getguarantee();
      }
    },
    openUrl() {
      window.open("./html/zhuce.html");
    },
    beforeAvatarUpload(file) {
      let isJPG;
      if (file.type === "image/jpeg") {
        isJPG = true;
      } else if (file.type === "image/png") {
        isJPG = true;
      } else {
        isJPG = false;
      }

      if (!isJPG) {
        this.$message.error("上传文件只能是 JPG 格式 或者 PNG 格式!");
        return false;
      }

      return isJPG;
    },
    changedbType() {
      this.getguarantee();
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>


<style lang="scss" scoped>
#newsdetail {
  .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img {
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }
  .center_box {
    width: 1500px;
    margin: 20px auto 0 auto;
    overflow: hidden;
    padding: 30px 35px 10px 35px;
    background: #fff;
    .detail_tit {
      font-size: 24px;
      text-align: center;
      font-weight: bold;
    }
    .detail_stit {
      font-size: 16px;
      font-weight: bold;
      padding-left: 14px;
      border-left: 4px solid #ff8d24;
      margin-top: 30px;
    }
    .detail_sbox {
      margin-top: 20px;
      background-color: #f5f6fa;
      padding: 20px;
      line-height: 32px;
      font-size: 16px;
      span {
        color: #8a8a8b;
      }
    }
  }
  .steps_box {
    .mysteps {
      padding: 40px 0 20px 0;
      border: 2px solid #303643;
      border-radius: 10px;
      margin-top: 27px;
      & >>> .el-step.is-horizontal .el-step__line {
        top: 20px;
      }
      & >>> .el-step__icon {
        width: 40px;
        height: 40px;
        font-size: 16px;
      }
      & >>> .el-step__head.is-finish {
        color: #fff;
        border-color: #303643;
        .el-step__icon.is-text {
          background-color: #303643;
        }
      }
      & >>> .el-step__title.is-finish {
        color: #303643;
        font-weight: bold;
      }
    }
  }
  .result_img {
    text-align: center;
    margin-top: 80px;
    margin-bottom: 40px;
  }
  .result_txt {
    margin-top: 40px;
  }

  .ser_form {
    & >>> .el-form-item__label {
      font-size: 16px;
      font-weight: bold;
      color: #303643;
    }
    & >>> .el-input__inner::placeholder {
      color: #999;
    }
  }
  .pagetit {
    text-align: center;
    margin-top: 56px;
    margin-bottom: 44px;
  }
  .form_box {
    margin: 0 auto;
  }
  .s_form_t {
    & >>> .el-form-item__label {
      font-size: 14px;
    }
  }
  .inlineInput {
    & >>> .el-input__inner {
      width: 400px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
    & >>> .el-select__caret {
      color: #303643;
    }
    & >>> .el-date-editor.el-input,
    & >>> .el-date-editor.el-input__inner {
      width: 400px;
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
  }

  .rzxz_box {
    margin: 18px auto 0 auto;
    width: 420px;
    padding: 16px 54px 16px 26px;
    background: #fff6ef;
    border: 1px dashed #ff8d24;
    border-radius: 6px;
    .rzxz_tit {
      font-size: 16px;
      color: #ff8d24;
      font-weight: bold;
    }
    .rzxz_txt {
      font-size: 14px;
      margin-top: 14px;
      line-height: 24px;
    }
  }
  .page1 {
    width: 550px;
    margin: 0 auto;
  }
  .page2 {
    .page_money {
      background: #f5f6fa;
      padding: 40px 0;
      text-align: center;
      position: relative;
      .num {
        font-size: 36px;
        color: #d52c00;
        font-weight: bold;
      }
      .txt {
        font-size: 14px;
      }
      .tips {
        position: absolute;
        color: red;
        font-size: 22px;
        left: 20px;
        top: 20px;
      }
    }
    .cert_b_box {
      margin-top: 34px;
    }
    .cert_box {
      .cert_tt {
        font-size: 16px;
        padding-left: 14px;
        border-left: 4px solid #ff8d24;
        font-weight: bold;
      }
    }
    .cert_tt_bg {
      background: #f5f6fa;
      width: 420px;
      height: 260px;
      border-radius: 10px;
      overflow: hidden;
      margin-top: 28px;
      .cert_tt_bg_t {
        font-size: 16px;
        font-weight: bold;
        margin-top: 30px;
        margin-left: 36px;
        margin-bottom: 20px;
      }
      .cert_tt_bg_b {
        font-size: 14px;
        line-height: 42px;
        margin-left: 36px;
      }
      .zf_t {
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        margin: 12px 0;
      }
      .zf_c {
        text-align: center;
      }
      .zf_b {
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        text-align: center;
        margin-top: 10px;
      }
    }
    .blue {
      background-color: #1f79fb;
    }
    .green {
      background-color: #2db047;
    }
    .checkspan {
      text-align: center;
      margin-bottom: 28px;
    }
    .checkbox_txt {
      font-size: 14px;
    }
    .a_link {
      color: #ff9f54;
      cursor: pointer;
    }
    .file_box {
      width: 300px;
      margin: 30px 0 0 0;
      .el-upload__tip {
        color: #d52c00;
        font-size: 14px;
      }
      .file_btn {
        width: 120px;
        height: 40px;
        background: #f5f6fa;
        border: 1px solid #bbbbbb;
        border-radius: 4px;
        color: #404040;
      }
    }
  }
  .page4 {
    .page4_tit {
      font-size: 18px;
      font-weight: bold;
      color: #666666;
      line-height: 24px;
      text-align: center;
    }
    .page4_center {
      margin-top: 40px;
      text-align: center;
    }
    .dialogRadio {
      text-align: center;
      & >>> .el-radio-button {
        margin: 10px 30px;
        display: block;
      }

      & >>> .el-radio-button__inner {
        border: none;
        border-radius: 2px;
        background-color: #e7e7e7;
        padding: 35px 0;
        // padding: 35px 50px;
        width: 300px;
        border: 2px solid #e7e7e7;
        color: #303643;
      }
      & >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: #fff;
        border: 2px solid #ff8d24;
        box-shadow: none;
      }
    }
  }
  .certbtn_box {
    width: 120px;
    margin: 42px auto 10px auto;
  }
  .certbtn {
    height: 42px;
    background: #303643;
    border-radius: 2px;
    color: #fff;
    border: none;
    width: 100%;
  }
  .certbtn_c {
    width: 100%;
    height: 42px;
    background: #ffffff;
    border: 1px solid #303643;
    border-radius: 2px;
  }
  .certbtn_c:focus,
  .certbtn_c:hover {
    color: inherit;
  }
  .diolg_btn {
    width: 120px;
  }
  .mycheck_box {
    & >>> .el-radio-button {
      margin: 0 20px;
    }

    & >>> .el-radio-button__inner {
      border: none;
      border-radius: 2px;
      background-color: #e8ecf8;
    }
    & >>> .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #303643;
    }
  }
  .danbaotypebtn {
    text-align: center;
    margin-top: 40px;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/project/Detail.vue